<template>
  <div class="crumbs flex items-center">
    <div v-for="(crumb, index) in crumbs" :key="`crumbs-${index}`">
      <TypeBody
        :variant="$options.Typography.Body.CAPTION"
        tag="nuxt-link"
        :to="crumb.to"
      >
        <span v-if="index !== 0">&nbsp;</span>
        <span class="capitalize">{{ crumb.label }}&nbsp;</span>
        <span v-if="index !== crumbs.length - 1">></span>
      </TypeBody>
    </div>
  </div>
</template>

<script>
import { defineComponent } from '@vue/composition-api';
import { TypeBody, constants } from '@bambeehr/pollen';
const { Typography } = constants;

export default defineComponent({
  name: 'Crumbs',
  Typography,
  components: { TypeBody },
  props: {
    crumbs: {
      type: Array,
      default: () => [],
    },
  },
  setup() {},
});
</script>

<style scoped>
.nuxt-link-exact-active {
  @apply cursor-default;
}
</style>
